import type { ReactNode } from "react";
import type { VariantProps } from "class-variance-authority";
import { ArrowRight } from "lucide-react";
import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface QuizActionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
  className?: string;
  withArrow?: boolean;
  /** Defaults to the quieter navigation style; use "default" for check actions. */
  variant?: VariantProps<typeof buttonVariants>["variant"];
  size?: VariantProps<typeof buttonVariants>["size"];
}

export const QuizActionButton = ({
  onClick,
  disabled = false,
  children,
  className,
  withArrow = true,
  variant = "default",
  size = "xl",
}: QuizActionButtonProps) => {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled}
      className={cn(className)}
    >
      {children}
      {withArrow && <ArrowRight className="h-4 w-4" aria-hidden="true" />}
    </Button>
  );
};
